<template>
  <div>
    <push-detail-link v-for="writeLayout in writeLayouts" :key="`pushComp${writeLayout}`" v-if="showLayout"
                     :writeLayout="writeLayout" :pushData="pushData" :timezoneData="timezoneData"></push-detail-link>
  </div>
</template>

<script>

import alertMixins from "@/mixins/alertMixins";
import EventBus from "@/utils/event-bus";
import util from "@/mixins/util";
import pushValidator from "@/mixins/validators/pushValidator";
import elFileMixins from "@/mixins/elFileMixins";
import pushUtil from "@/components/push/pushUtil";
import PushDetailLink from "@/components/push/PushDetailLink";
import DeleteClass from "@/mixins/deleteClass";


export default {
  name: "PushDetailComponent",
  mixins: [alertMixins, pushUtil, pushValidator, elFileMixins],
  components: {PushDetailLink},
  inject: ['changeLoading'],
  provide() {
    return {
      pushDetailSetData: this.setData,
      pushDetailDelete: this.runDeleteConfirm
    }
  },
  props: {
    pushType: {},
    pushKey: {default: 0},
  },
  data() {
    return {
      writeLayouts: [],
      writeFunc: '',
      writeApiParamSet: {},
      parsingData: {},
      directUrl: '',
      directType: '',
      keyName: '',
      writeSuccessType: 1,
      writeFailTypes: {},
      getFunc: '',
      detailApiParamsSet: {},
      pushData: {},
      timezoneData : [],
      //필터
      deleteApiParamsSet : {},
      deleteSuccessType : 1,
      deleteFailTypes : {},
      deleteFunc : '',
      selectArr: [],
      deleteIndex: 0,
      DeleteClass: null,
      showLayout: false,
    }
  },
  created() {
    this.initFilterConfig();
    if (this.pushKey === 0) {
      this.initTemplateConfig();
    } else {
      // api가 연결 된다면 실행되는 메소드입니다.
      this.getPush();
    }
  },
  mounted() {
    EventBus.$on('deletePush', this.runDeleteConfirm);
    EventBus.$on('deleteBookPush', this.runDeleteBookConfirm);
  },
  beforeDestroy() {

    EventBus.$off('deletePush');
    EventBus.$off('deleteBookPush');
  },
  destroyed() {
  },
  computed: {},
  methods: {
    setData(key, value) {
      this[key] = value;
    },
    initTemplateConfig() {
      let configPush = this.returnPushConfig(this.pushType);
      this.writeLayouts = configPush.writeLayouts;
    },
    initFilterConfig() {
      let configPush = this.returnPushConfig(this.pushType);
      this.writeFunc = configPush.writeFunc;
      this.writeApiParamSet = configPush.writeApiParamSet;
      this.parsingData = configPush.parsingData;
      this.getFunc = configPush.getFunc;
      this.detailApiParamsSet = configPush.detailApiParamsSet;
      this.directUrl = configPush.directUrl;
      this.directType = configPush.directType;
      this.keyName = configPush.keyName;
      this.writeSuccessType = configPush.writeSuccessType;
      this.writeFailTypes = configPush.writeFailTypes;
      this.deleteFunc= configPush.deleteFunc;
      this.writeKey = configPush.writeKey;
    },
    getPush() {
      let params = JSON.parse(JSON.stringify(this.detailApiParamsSet));
      params[this.keyName] = this.pushKey
      this.$api.$push[this.getFunc](params).then(res => res.Data.Result).then(res => {
        if (res.Info.type != 1 && res.List.length === 0) {
          this.createAlert({
            title: '',
            content: '데이터를 불러올 수 없습니다.',
            btnText: '확인',
            hide: () => {
              this.$router.back();
            }
          });
          return;
        }
        this.pushData = res.List[0];
        this.selectArr = [res.List[0].as_idx];
        this.initTemplateConfig();
        this.newDeleteClass();
        this.getTimezoneList();
        this.showLayout = true
      })
    },
    returnPushType(type) {
      if (type == this.writeSuccessType) {
        return true;
      } else {
        return util.isEmpty(this.writeFailTypes[type]) ? '저장에 실패하였습니다.' : this.writeFailTypes[type]
      }
    },
    afterFunc(key) {
      this.changeLoading(false);
      if (this.pushKey != 0) {
        EventBus.$emit('refundListUpdateAfterFunc', this.keyName, Number(this.pushKey));
      } else {
        EventBus.$emit('refundListAddAfterFunc');
      }
      let detailKey = key;
      this.createAlert({
        title: '',
        content: '저장되었습니다.',
        btnText: '확인',
        hide: () => {
          if (this.directType === 'back') {
            this.$router.back();
            return false;
          }
          if (this.directUrl === '') {
            this.writeLayouts = [];
            this.deleteFiles = [];
            this.getPush();
            return false;
          }
          let url = this.directUrl;
          if (this.directType === 'detail') {
            url = url + detailKey;
          }
          this.$router.push(url);
        }
      })
    },
    getTimezoneList() {
      try {
        this.$api.$config.getTimeZone().then(res => res.Data.Result).then(res => {
          console.log("data",res)
          if (res.Info.type != 1 && res.List.length <= 0) {
            return false
          } else {

            this.timezoneData = res.List;
          }
        })
      } catch (e) {
        console.log(e)
      }
    },
    runDeleteConfirm() {
      this.createConfirm({
        content: '정말 삭제하시겠습니까?',
        confirm: () => {
          this.runDelete();
        }
      })
    },
    runDelete() {
      this.changeLoading(true);
      this.DeleteClass.runDelete(this.pushKey);
    },
    deleteAfterFunc() {
      this.changeLoading(false);
      this.createAlert({
        content: '삭제되었습니다.',
        hide: () => {
          this.deleteIndex = 0;
          this.$router.back()
        }
      })
    },
    newDeleteClass() {
      let deleteOptions = {
        func: this.$api.$push[this.deleteFunc],
        apiParamSet: this.deleteApiParamsSet,
        keyName: this.writeKey,
        successType: this.deleteSuccessType,
        errorTypes: this.deleteFailTypes,
        afterFunc: this.deleteAfterFunc,
      }
      this.DeleteClass = new DeleteClass(deleteOptions);
    },
    runDeleteBookConfirm(){
      if (this.selectArr.length === 0) {
        this.errorAlert('목록을 선택해주세요.');
        return false;
      }
      this.createConfirm({
        content: '정말 예약을 취소하시겠습니까?',
        confirm: () => {
          this.runDeleteBook();
        }
      })
    },
    runDeleteBook(){
      let params = {
        as_idx : this.pushKey
      }
      try{
        this.changeLoading(true);
        this.$api.$push.deleteBookPush(params).then(res => res => res.Data.Result).then(res=>{
          let type = 1;
          if(type === 1){
            this.deleteBookAfterFunc();
          }
        });
      }catch (e){
        this.changeLoading(false)
        console.log(e);
      }

    },
    deleteBookAfterFunc(){
      this.changeLoading(false);
      this.createAlert({
        content: '예약 취소되었습니다.',
        hide: () => {
          this.getPush()
          return false;
        }
      })
    },
  },
  watch: {},
}
</script>

<style scoped>

</style>
